const BASE_STRIPE_ACCOUNT_LINK = 'https://billing.stripe.com/p/login/28E8wP3zp0F93uS29nbEA00?prefilled_email=';

((window, document) => {
    const accountScreen = document.getElementById('account-edit');
    const accountStripeLink = document.getElementById('account-stripe-link');

    const accountUpdateContactForm = document.getElementById('account-update-contact');
    const accountUpdateContactFormShow = document.getElementById('account-update-contact-show');

    const accountCancelPlanLink = document.querySelector('.account__link--cancel');

    if (accountScreen) {
        const loggedIn = accountScreen.getAttribute('data-loggedIn');

        if (loggedIn !== 'true') {
            window.location.replace('/login');
        }

        const email = accountScreen.getAttribute('data-email');

        if (email) {
            accountStripeLink.href = BASE_STRIPE_ACCOUNT_LINK + encodeURIComponent(email);
        }
    }

    if (accountUpdateContactFormShow) {
        accountUpdateContactFormShow.addEventListener('click', () => {
            accountUpdateContactForm.classList.remove('d-none');
        })
    }

    setupUpdateContactForm();

    if (accountCancelPlanLink) {
        accountCancelPlanLink.href = '#';
    }
})(window, document);

function setupUpdateContactForm() {
    const form = document.getElementById('account-update-contact');
    const formSuccessMsg = document.getElementById('account-update-contact-success');

    if (form) {
        const initialName = form.name.value;
        const initialEmail = form.email.value;

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (form.name.value !== initialName) {
                try {
                    const nameUpdateReq = await fetch('/members/api/member/', {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            name: form.name.value,
                        }),
                    });
                } catch (e) {
                    console.error(e);
                }
            }

            if (form.email.value !== initialEmail) {
                try {
                    const session = await fetch('/members/api/session').then(resp => resp.text())

                    const emailChange = fetch('/members/api/member/email', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            identity: session,
                            email: form.email.value
                        }),
                    }).then(resp => resp);
                } catch (e) {
                    console.error(e);
                }
            }

            form.classList.add('d-none');
            formSuccessMsg.classList.remove('d-none');
        })
    }
}